import { render, staticRenderFns } from "./FirstColumn.vue?vue&type=template&id=5a65fc2b"
import script from "./FirstColumn.vue?vue&type=script&lang=js"
export * from "./FirstColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports